/* ===========================================================================
   MM : RECHERCHE RAPIDE (palette Ctrl+F)
   ---------------------------------------------------------------------------
   Ouverture : Cmd/Ctrl+F (debrayable en reglage de section), Cmd/Ctrl+K, et
   tout element portant data-mm-recherche (pour brancher une entree de nav ou
   un bouton mobile plus tard, sans revenir ici).

   Le detournement de Ctrl+F reste reversible a l'usage : palette ouverte et
   champ deja focus, un second Ctrl+F ferme la palette et n'est PAS annule,
   donc la recherche native du navigateur s'ouvre. Personne n'est enferme.

   Requetes : l'API predictive native (routes.predictive_search_url), pages +
   articles + produits, avec anti-rebond et AbortController pour jeter les
   reponses en retard. Sans JS, le champ est un vrai formulaire vers /search.

   Verrou de defilement : la classe .stop-scrolling sur l'element html, la
   meme que le menu et le panier, surveillee par mm-opti-gsi.js qui met Lenis
   en pause. Le corps de la palette porte data-lenis-prevent et garde son
   defilement natif.
   =========================================================================== */

(function () {
	'use strict';

	var DEBOUNCE = 180;
	var MIN_QUERY = 2;
	var LIMIT_PAR_TYPE = 5;

	function init(root) {
		var rr = root || document.querySelector('[data-rr]');
		if (!rr || rr.dataset.mmRrReady === '1') return;
		rr.dataset.mmRrReady = '1';

		var champ = rr.querySelector('[data-rr-champ]');
		var resultats = rr.querySelector('[data-rr-resultats]');
		var acces = rr.querySelector('[data-rr-acces]');
		var rien = rr.querySelector('[data-rr-rien]');
		var annonce = rr.querySelector('[data-rr-annonce]');
		var tout = rr.querySelector('[data-rr-tout]');
		var panneau = rr.querySelector('.mm-rr__panneau');
		if (!champ || !resultats || !panneau) return;

		var captureF = rr.dataset.captureF !== 'false';
		var urlPredictive = rr.dataset.urlPredictive || '/search/suggest';
		var urlRecherche = rr.dataset.urlRecherche || '/search';
		var libelles = {
			pages: rr.dataset.libellePages || 'Pages',
			articles: rr.dataset.libelleArticles || 'Articles',
			products: rr.dataset.libelleProduits || 'Produits'
		};

		var dernierFocus = null;
		var minuterie = null;
		var controleur = null;
		var options = [];
		var actif = -1;
		var defileur = creerDefileur(
			rr.querySelector('.mm-rr__corps'),
			rr.querySelector('[data-rr-defilement]')
		);

		/* ---------- Ouverture / fermeture ---------- */

		function estOuverte() {
			return rr.classList.contains('is-open');
		}

		function ouvrir() {
			if (estOuverte()) return;
			dernierFocus = document.activeElement;
			rr.classList.add('is-open');
			document.documentElement.classList.add('stop-scrolling');
			if (defileur) defileur.start();
			champ.focus();
			champ.select();
			/* LA LISTE NAVIGABLE DOIT EXISTER DES L'OUVERTURE.
			   montrerAcces() n'etait appelee que par l'evenement input, donc
			   seulement apres une premiere frappe : palette ouverte, options
			   restait a sa valeur initiale (vide) et les fleches n'avaient
			   rien a parcourir, alors que le pied annonce « naviguer » des
			   l'ouverture. Poser l'etat ici plutot que d'attendre une saisie.
			   Rouverte sur une requete deja tapee, on reprend la main sur les
			   resultats affiches au lieu de les effacer. */
			if (champ.value.trim().length < MIN_QUERY) {
				montrerAcces();
			} else {
				options = Array.prototype.slice.call(resultats.querySelectorAll('[role="option"]'));
			}
		}

		function fermer() {
			if (!estOuverte()) return;
			rr.classList.remove('is-open');
			document.documentElement.classList.remove('stop-scrolling');
			if (defileur) defileur.stop();
			if (controleur) controleur.abort();
			if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
		}

		/* ---------- Clavier global ---------- */

		document.addEventListener('keydown', function (event) {
			var touche = (event.key || '').toLowerCase();
			var mod = event.metaKey || event.ctrlKey;

			if (mod && (touche === 'f' || touche === 'k')) {
				if (touche === 'f' && !captureF) return;
				if (!estOuverte()) {
					event.preventDefault();
					ouvrir();
					return;
				}
				/* Deja ouverte. Second Ctrl+F avec le champ focus : on rend la
				   main au navigateur, sans preventDefault : sa recherche native
				   s'ouvre par-dessus la page. */
				if (touche === 'f' && document.activeElement === champ) {
					fermer();
					return;
				}
				event.preventDefault();
				champ.focus();
				champ.select();
				return;
			}

			if (touche === 'escape' && estOuverte()) {
				event.preventDefault();
				fermer();
			}
		});

		/* Ouverture par un element declencheur, ou par le scrim pour fermer. */
		document.addEventListener('click', function (event) {
			if (event.target.closest('[data-mm-recherche]')) {
				event.preventDefault();
				ouvrir();
			}
		});
		Array.prototype.forEach.call(rr.querySelectorAll('[data-rr-fermer]'), function (n) {
			n.addEventListener('click', fermer);
		});

		/* Piege a focus : la palette est aria-modal, Tab boucle dedans. */
		panneau.addEventListener('keydown', function (event) {
			if (event.key !== 'Tab') return;
			var focusables = panneau.querySelectorAll('input, button, a[href]');
			if (!focusables.length) return;
			var premier = focusables[0];
			var dernier = focusables[focusables.length - 1];
			if (event.shiftKey && document.activeElement === premier) {
				event.preventDefault();
				dernier.focus();
			} else if (!event.shiftKey && document.activeElement === dernier) {
				event.preventDefault();
				premier.focus();
			}
		});

		/* ---------- Requete ---------- */

		champ.addEventListener('input', function () {
			clearTimeout(minuterie);
			var q = champ.value.trim();
			if (q.length < MIN_QUERY) {
				montrerAcces();
				return;
			}
			minuterie = setTimeout(function () { chercher(q); }, DEBOUNCE);
		});

		function chercher(q) {
			if (controleur) controleur.abort();
			controleur = new AbortController();
			/* suggest.json : le JSON brut de l'API predictive, sans rendu de
			   section. routes.predictive_search_url porte deja le prefixe de
			   locale s'il y en a un. */
			var url = urlPredictive + '.json?q=' + encodeURIComponent(q)
				+ '&resources%5Btype%5D=page,article,product'
				+ '&resources%5Blimit%5D=' + LIMIT_PAR_TYPE;

			fetch(url, { signal: controleur.signal })
				.then(function (r) { return r.json(); })
				.then(function (d) {
					var groupes = (d && d.resources && d.resources.results) || {};
					rendre(q, groupes);
				})
				.catch(function (erreur) {
					if (erreur && erreur.name === 'AbortError') return;
					/* Reseau en panne : la palette reste un formulaire vers /search. */
					montrerRien();
				});
		}

		/* ---------- Rendu ---------- */

		function montrerAcces() {
			resultats.hidden = true;
			resultats.innerHTML = '';
			if (rien) rien.hidden = true;
			if (acces) acces.hidden = false;
			/* LES ACCES DIRECTS SE PARCOURENT AUSSI AUX FLECHES. La liste des
			   options etait vidée ici, alors que ces liens sont a l'ecran et
			   cliquables : palette ouverte sur un champ vide, les fleches ne
			   trouvaient rien, alors que le pied annonce « naviguer » des
			   l'ouverture. Le champ pointe donc sur la listbox reellement
			   visible, celle des acces. */
			options = acces ? Array.prototype.slice.call(acces.querySelectorAll('[role="option"]')) : [];
			actif = -1;
			champ.setAttribute('aria-expanded', options.length ? 'true' : 'false');
			champ.setAttribute('aria-controls', options.length ? 'mm-rr-acces-liste' : 'mm-rr-resultats');
			champ.removeAttribute('aria-activedescendant');
			deselectionner();
			majTout('');
		}

		/* Aucun element pre-selectionne au depart, volontairement : Entree sur
		   un champ vide doit continuer d'envoyer vers /search, comportement
		   natif du formulaire. La premiere fleche active le premier element. */
		function deselectionner() {
			options.forEach(function (opt) {
				opt.classList.remove('is-actif');
				opt.setAttribute('aria-selected', 'false');
			});
		}

		function montrerRien() {
			resultats.hidden = true;
			resultats.innerHTML = '';
			if (acces) acces.hidden = true;
			if (rien) rien.hidden = false;
			champ.setAttribute('aria-expanded', 'false');
			options = [];
			actif = -1;
			champ.removeAttribute('aria-activedescendant');
			annoncer(0);
		}

		function rendre(q, groupes) {
			var ordre = ['pages', 'articles', 'products'];
			var html = '';
			var total = 0;

			ordre.forEach(function (type) {
				var items = groupes[type] || [];
				if (!items.length) return;
				html += '<p class="mm-rr__groupe" role="presentation">' + echapper(libelles[type]) + '</p>';
				html += '<div class="mm-rr__liste" role="presentation">';
				items.forEach(function (item) {
					var titre = surligner(item.title || '', q);
					html += '<a href="' + echapper(item.url || '#') + '" class="mm-rr__ligne" role="option" id="mm-rr-opt-' + total + '" aria-selected="false">'
						+ '<span class="mm-rr__titre">' + titre + '</span>'
						+ '</a>';
					total += 1;
				});
				html += '</div>';
			});

			if (!total) {
				montrerRien();
				return;
			}

			resultats.innerHTML = html;
			resultats.hidden = false;
			if (defileur) defileur.haut();
			if (acces) acces.hidden = true;
			if (rien) rien.hidden = true;
			champ.setAttribute('aria-expanded', 'true');
			champ.setAttribute('aria-controls', 'mm-rr-resultats');
			options = Array.prototype.slice.call(resultats.querySelectorAll('[role="option"]'));
			activer(0);
			annoncer(total);
			majTout(q);
		}

		/* La correspondance se cherche sur le texte BRUT, et chaque morceau est
		   echappe separement : chercher dans du texte deja echappe pouvait
		   couper une entite en deux (un « a » trouve au milieu d'un &amp;
		   cassait le HTML). Insensible a la casse, pas aux accents : suffisant
		   pour des requetes reelles, et sans le piege des longueurs qui
		   divergent apres normalisation Unicode. */
		function surligner(texte, q) {
			var brut = String(texte);
			var idx = brut.toLowerCase().indexOf(String(q).toLowerCase());
			if (idx === -1) return echapper(brut);
			var fin = idx + q.length;
			return echapper(brut.slice(0, idx))
				+ '<mark>' + echapper(brut.slice(idx, fin)) + '</mark>'
				+ echapper(brut.slice(fin));
		}

		function echapper(s) {
			return String(s)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;');
		}

		function annoncer(total) {
			if (!annonce) return;
			annonce.textContent = total === 0
				? 'Aucun résultat'
				: total + (total === 1 ? ' résultat' : ' résultats');
		}

		function majTout(q) {
			if (!tout) return;
			tout.href = q ? urlRecherche + '?q=' + encodeURIComponent(q) : urlRecherche;
		}

		/* ---------- Navigation au clavier dans les resultats ---------- */

		function activer(index) {
			if (!options.length) return;
			actif = Math.max(0, Math.min(index, options.length - 1));
			options.forEach(function (opt, i) {
				opt.classList.toggle('is-actif', i === actif);
				opt.setAttribute('aria-selected', String(i === actif));
			});
			champ.setAttribute('aria-activedescendant', options[actif].id);
			options[actif].scrollIntoView({ block: 'nearest' });
		}

		champ.addEventListener('keydown', function (event) {
			if (event.key === 'ArrowDown') {
				event.preventDefault();
				activer(actif + 1);
			} else if (event.key === 'ArrowUp') {
				event.preventDefault();
				activer(actif - 1);
			} else if (event.key === 'Enter') {
				/* Un resultat actif : on y va. Sinon le formulaire part vers
				   /search, comportement natif conserve. */
				if (options.length && actif >= 0) {
					event.preventDefault();
					window.location.href = options[actif].getAttribute('href');
				}
			}
		});
	}

	/* -----------------------------------------------------------------------
	   DEFILEMENT LISSE DU CORPS
	   ---------------------------------------------------------------------
	   Meme montage que le tiroir du menu (mm-header.js) : une instance Lenis
	   imbriquee sur le corps de la palette, molette seulement. Pas de
	   syncTouch : au doigt, l'inertie native EST le defilement lisse, et la
	   lib se battrait avec le systeme (constate sur le tiroir). La detection
	   de data-lenis-prevent s'arrete au rootElement de chaque instance, donc
	   l'attribut du corps ecarte l'instance du document sans gener celle-ci.
	   Sans Lenis, ou en mouvement reduit, le defilement natif reprend :
	   le lissage est un bonus, jamais une dependance.
	   ----------------------------------------------------------------------- */

	function creerDefileur(enveloppe, contenu) {
		if (!enveloppe || !contenu) return null;
		if (typeof Lenis === 'undefined') return null;
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

		var lenis;
		try {
			lenis = new Lenis({
				wrapper: enveloppe,
				content: contenu,
				orientation: 'vertical',
				gestureOrientation: 'vertical',
				smoothWheel: true,
				syncTouch: false,
				lerp: 0.11
			});
		} catch (erreur) {
			return null;   /* lib absente ou d'une autre version : le menu vit sans */
		}

		var trame = null;
		function boucle(temps) {
			lenis.raf(temps);
			trame = requestAnimationFrame(boucle);
		}

		return {
			start: function () {
				lenis.resize();
				lenis.start();
				if (trame === null) trame = requestAnimationFrame(boucle);
			},
			stop: function () {
				lenis.scrollTo(0, { immediate: true, force: true });
				lenis.stop();
				if (trame !== null) {
					cancelAnimationFrame(trame);
					trame = null;
				}
			},
			haut: function () {
				lenis.scrollTo(0, { immediate: true, force: true });
			}
		};
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', function (event) {
		var rr = event.target.querySelector ? event.target.querySelector('[data-rr]') : null;
		if (rr) init(rr);
	});
	document.addEventListener('shopify:section:unload', function () {
		document.documentElement.classList.remove('stop-scrolling');
	});
})();
